/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      // Show update banner if there's a waiting worker
      if (registration && registration.waiting) {
        // Check if banner already exists to avoid duplicates
        if (!document.getElementById('sw-update-banner')) {
          // Create banner container
          const banner = document.createElement('div')
          banner.id = 'sw-update-banner'
          banner.className = 'fixed inset-x-0 bottom-0 z-[9999] bg-neutral-900 text-white'

          // Create banner content
          const content = document.createElement('div')
          content.className = 'flex items-center justify-between p-4'
          content.innerHTML = '<span>Hay una nueva versión disponible.</span>'

          // Create update button
          const updateBtn = document.createElement('button')
          updateBtn.textContent = 'Actualizar ahora'
          updateBtn.className = 'bg-emerald-500 hover:bg-emerald-600 text-white rounded-full px-4 py-2 min-h-[44px]'
          
          // Add event listener to handle update
          updateBtn.addEventListener('click', () => {
            if (registration && registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' })
              
              // Wait a bit for the message to be processed, then reload
              setTimeout(() => {
                window.location.reload()
              }, 100)
            }
          })

          // Assemble the banner
          content.appendChild(updateBtn)
          banner.appendChild(content)
          document.body.appendChild(banner)
        }
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
